import React from 'react';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import CookiesBlock from '../../Components/CookiesBlock';

const Terms = () => {

  return (
    <div className="terms-layout">
      <Navbar />
      <CookiesBlock />
      <section className="terms-page">
        <div className="container">
          <header className="terms-intro">
            <h3>MediaLink Beach Online</h3>
            <h3>General Terms of Business (the “Terms”)</h3>
          </header>

          <div className="terms-content">
            <ol>
              <li><strong>Process for entering into Contracts</strong>
                <ol>
                  <li>When the parties agree terms for us to provide Services and/or Deliverables to you, we will capture those terms in writing (the Order Form).</li>
                  <li>Whichever is earlier of you signing the Order Form, completing an online registration form and clicking “accept” or similar assent where applicable, is your offer to purchase the Services and/or Deliverables from us on these Terms (an “Offer”). Where an individual representative of your organisation signs an Order Form, completes an online registration form or gives similar assent, you confirm that they have the authority to do so on your behalf. Our signing of the Order Form, sending of a confirmation email or supplying Services and/or Deliverables, (which includes any necessary preparatory work), to you in accordance with the Order Form is acceptance of your Offer (“Acceptance”) and creates a 
                    binding contract consisting of the Order Form, these Terms and any relevant Module Terms (a “Contract”).</li>
                  <li>No other terms and conditions, (including, without limitation, your own terms, the pre-printed terms 
                    on the back of any PO, or those implied), will apply to the Contract unless we have agreed in writing. </li>
                </ol>
              </li>

              <li><strong>Term and Termination</strong>
                <ol>
                  <li>The Contract starts on the Start Date specified in the Order Form (the “Start Date”) and will continue until the earlier of:
                    <ol>
                      <li>the specific end date included in the Order Form (if any);</li>
                      <li>termination by notice in accordance with any specific provisions of the Order Form (if any);</li>
                      <li>or termination in accordance with these Terms. </li>
                    </ol>
                  </li>

                  <li>Neither party is entitled to terminate, delay, suspend or vary the Contract other than in accordance with these Terms</li>
                  <li>A party may immediately terminate the Contract by giving the other party written notice if the other party materially or repeatedly breaches the terms of that Contract, and, (where the breach(es) are capable of remedy), 
                    fails to remedy such breach(es) within 30 days of receiving written notice requesting remedy of the breach(es).</li>
                  <li> A party may immediately terminate the Contract if the other party is subject to an Insolvency Event.</li>
                </ol>
              </li>
            </ol>
            
<li><strong>Our warranties</strong>
<ol>
<li ><span >We warrant that:</span></li>
<ol>
<li ><span >we will use reasonable skill and care in providing the Services and Deliverables;</span></li>
<li ><span >the Services and Deliverables will conform to any applicable industry standard;</span></li>
<li ><span >the Services and Deliverables will comply with any applicable law;</span></li>
<li ><span >we will meet or exceed any service levels in the Order Form; and&nbsp;</span></li>
<li ><span >the Services and Deliverables will conform with any specification in the Order Form (a </span><strong>&ldquo;Specification&rdquo;</strong><span >).</span></li>
</ol>
</ol>
</li>

<li><strong>Fees and Payment&nbsp;</strong>
  <ol>
    <li ><span >Unless otherwise agreed in writing as part of the Contract, we may invoice you for Services and Deliverables in full and in advance.&nbsp;</span></li>
    <li ><span >You must pay each undisputed invoice:</span>
  <ol>
    <li ><span >by the date agreed in the Contract; or&nbsp;</span></li>
    <li ><span >if no such date has been agreed, within 30 days of the date of the invoice.</span></li>
  </ol>
</li>
  <li ><span >You are not entitled to set-off any amount we owe you against any amount you owe us.</span></li>
  <li ><span >A party may charge the other interest on any late payments. Interest accrues each day from the original due date for payment until the actual date the overdue amount is paid at a rate equal to the lesser of 1.0% per month and maximum rate permitted by applicable law.&nbsp;</span></li>
  <li ><span >You must reimburse us for any reasonable costs and expenses we incur in i) recovering any late payments from you. On your written request we will provide evidence of such costs and/or expenses.</span></li>
  <li ><span >We may suspend the provision of any Services or access to any Deliverables if you owe us anything, from 14 days of the date the debt became overdue.</span></li>
  <li ><span >On termination of the Contract anything you owe us in relation to the Contract will become due immediately. We may recover from you any costs we incur in collecting overdue monies from you.</span></li>
  <li ><span >Amounts payable by you in relation to the Contract are exclusive of VAT, sales, use and any similar taxes unless expressly agreed in writing as part of the Contract. If you do not pay such taxes you will be responsible for their payment to relevant authorities. We reserve the right to collect taxes and our reasonable costs of collection from you at any time, except with respect to any taxes based on our net income. In certain jurisdictions, we may be required to collect and remit sales tax in connection with your purchase of Services and Deliverables. Any such taxes will be added to the fees and reflected on your invoice.</span></li>
  <li ><span >Following the first anniversary of the Start Date, but not more than once in each year of a Contract, we may automatically increase any fees by an amount not exceeding the lower of (i) the percentage increase in the Applicable Price Index in the preceding year plus 5% and (ii) the maximum amount permitted by law.</span></li>

</ol>
</li>

<li><strong><strong>Incorporation of Website Terms</strong></strong>
<p><span >Where you access Services or Deliverables via our website(s), your access (and use) will be governed by these terms in conjunction with the terms of use of that website (</span><strong>&ldquo;Website Terms&rdquo;</strong><span >). In the event of any conflict between these Terms and the Website Terms, these Terms will prevail and apply.&nbsp;</span></p>
</li>
<li><strong><strong>Intellectual property</strong></strong></li>

<ol>
<ol>
<li ><span >All Intellectual Property Rights in anything we supply are our property or the property of our third party licensors, and will not transfer to you by Contract.</span></li>
<li ><span >We grant you a non-transferable, non-exclusive, non-assignable, revocable, world-wide, royalty free limited license, without the right of sub-license, to access and use the Services and Deliverables for your own internal purposes during the term of the Contract.</span></li>
<li ><span >Any rights not expressly granted herein are reserved by us. To the extent that you acquire any right, title, or interest in or to any Ascential Property (other than with respect to such limited license), you hereby assign and convey all such right, title and interest therein to us.</span></li>
<li ><span >We acknowledge that the Customer Materials are your property and that you own all Intellectual Property Rights in and to the same.</span></li>
<li ><span >You agree that we (including our Affiliates) may freely use any data (including the Customer Materials) which we learn, acquire or obtain in connection with the performance of the Contract to improve the quality of our services and deliverables.&nbsp;</span></li>
<li ><span >We indemnify you against any loss, damages or reasonable costs you incur in connection with claims, demands, suits, or proceedings made or brought against you by a third party claiming that the Deliverables infringe the Intellectual Property Rights of a third party (a "Claim"); provided, however, that we will not have any liability to indemnify you for a Claim to the extent the alleged infringement arises from: (i) changes to the Deliverables made at your specific written direction; (ii) your </span><span >failure to use new or corrected versions of the Deliverables provided by us where you are notified that use of such new or corrected version is necessary to avoid infringement; (iii) the modification of the Deliverables by you or any third-party on your behalf other than as expressly contemplated by the Contract without our written consent; or, (iv) combination of the Deliverables with systems, materials or software other than as contemplated by&nbsp; the Contract.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >You must:&nbsp;</span></li>
<ol>
<li ><span >immediately give us written notice of a Claim (provided that your failure to so notify will not relieve us of our indemnification obligations hereunder except, and only to the extent, that we are prejudiced thereby);</span></li>
<li ><span >give us full control of the defense and settlement of the Claim (provided that (a) you may participate in the defense at your own expense and (b) we may not settle or defend any Claim unless we unconditionally release you from all liability in relation to that Claim); and</span></li>
<li ><span >provide us with all reasonable assistance in relation to the Claim at our expense.</span></li>
</ol>
<li ><span >If we believe that a Claim could prevent you from receiving or using all or any part of the relevant Services or Deliverables, we may:&nbsp;</span></li>
<ol>
<li ><span >procure the right for you to make continued use of the relevant Services and Deliverables;</span></li>
<li ><span >replace or modify the Deliverables so that they become non-infringing, as the case may be; or</span></li>
<li ><span >terminate the relevant Deliverables immediately on written notice to you, and refund to you any pre-payment in relation to such cancelled Deliverables.&nbsp;</span></li>
</ol>
<li ><span >You indemnify us against any loss, damage or reasonable costs we incur in connection with claims made or brought against us by a third party alleging that any Customer Materials infringe the Intellectual Property Rights of the third party. We must:</span></li>
<ol>
<li ><span >promptly give you written notice of the claim (provided, that our failure to so notify will not relieve you of your indemnification obligations hereunder except, and only to the extent, that you are prejudiced thereby);</span></li>
<li ><span >give you full control of the defense and settlement of the claim (provided that (a) we may participate in the defense at our own expense and (b) you may not settle or defend the claim unless you unconditionally release us from all liability in relation to the claim); and&nbsp;</span></li>
<li ><span >provide you with all reasonable assistance in relation to the claim at your expense.&nbsp;</span></li>
</ol>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Delivery and your obligation to enable our performance</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li ><span >You must provide us with such:&nbsp;</span></li>
<ol>
<li ><span >access to premises and facilities; and</span></li>
<li ><span >information, instructions and materials</span></li>
</ol>
</ol>
</ol>
<p><span >as we require from time to time to enable us to perform the Contract.</span></p>
<ol>
<ol>
<ol>
<li ><span >You agree that to the extent that you cause failure or delay to our performance of any obligation under the Contract, we will not be in breach, nor liable to you for any related loss.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Insurance</strong></strong></li>
</ul>
<p>&nbsp;</p>
<p><span >Each party must hold sufficient insurance to cover its potential liabilities under the Contract. This includes (without limitation) any insurance required by applicable law or specified on the Order Form.</span></p>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Compliance with applicable laws including those relating to data privacy&nbsp;</strong></strong></li>
</ul>
<p>&nbsp;</p>
<p><span >Both parties must comply with all applicable laws in connection with the provision and use of the Services and Deliverables, including but not limited to those related to data privacy and personal data.&nbsp;</span></p>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Anti-Bribery and Sanctions</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >Each party warrants that it will:</span></li>
<ol>
<li ><span >comply with all applicable laws, statutes and regulations relating to anti-bribery and anti-corruption;</span></li>
<li ><span >put in place, comply with and maintain codes of conduct and anti-bribery and anti-corruption policies as are appropriate to meet its statutory responsibilities in this regard; and&nbsp;</span></li>
<li ><span >promptly notify the other party of any request or demand for any undue financial or other advantage of any kind received by or on behalf of you in connection with the Contract.</span></li>
</ol>
<li ><span >We are part of an enlarged corporate group which pledges to trade legally and respect all laws including the Trade Sanctions imposed by EU and US Governments. We operate a Group Sanctions Policy which means that we cannot receive consideration from individuals or organizations based or residing in, or connected with, a country or organization which is subject to EU or US Government sanctions. We may refuse to accept an order from or provide Services and Deliverables to any such person or organization for any reason.</span></li>
<li ><span >Breach by either party of these Anti-Bribery and Sanctions provisions will be a material breach of the Contract.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Consequences of Termination</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >Termination of the Contract by either party will not affect the operation of any other Contract between the parties.&nbsp;</span></li>
<li ><span >Termination or expiration of the Contract, or any part thereof, will not affect the continuance in force of any provision of the Contract or the relevant constituent part which is expressly or by implication intended to survive termination.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Liability</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >Nothing in the Contract will operate to exclude or limit a party&rsquo;s liability for death or personal bodily injury caused by its or its employees or subcontractors&rsquo; negligence, or for any fraudulent misrepresentation by any of the foregoing or for any other liability which cannot be excluded or restricted by law or for any breach by you of the usage restrictions in any Module .&nbsp;&nbsp;</span></li>
<li ><span >Subject to the foregoing:</span></li>
<ol>
<li ><strong>neither party will be liable to the other arising out of or in connection with the Contract for any of the following types of losses, damages, or expenses of any kind arising out of or in connection with that Contract;</strong></li>
</ol>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>consequential;</strong></strong></li>
</ul>
<ul>
<li><strong>indirect;</strong></li>
</ul>
<ul>
<li><strong>special;</strong></li>
</ul>
<ul>
<li><strong>lost profits; *</strong></li>
</ul>
<ul>
<li><strong>lost revenue*;</strong></li>
</ul>
<ul>
<li><strong>lost sales*;</strong></li>
</ul>
<ul>
<li><strong>anticipated savings; and</strong></li>
</ul>
<ul>
<li><strong>losses, damages, or expenses arising from loss of data;</strong></li>
</ul>
<p>&nbsp;</p>
<p><strong>*Excludes the fees for Services agreed upon in the Order Form</strong></p>
<ol>
<ol>
<ol>
<ol>
<li ><strong>except for any liability under any indemnity in Clause 6 in relation to intellectual property, each party&rsquo;s total aggregate liability to the other arising out of or in connection with the Contract will be limited to two times the amount paid and payable pursuant to the Contract; and</strong></li>
<li ><strong>neither party will have any liability to the other party for any failure or delay in performing an obligation under the Contract because of any event beyond that party&rsquo;s or its subcontractors&rsquo; reasonable control.&nbsp;</strong></li>
</ol>
<li ><span >You are not entitled to rely on the exclusions of liability in this clause to relieve you from liability to pay monies payable to us.</span></li>
<li ><span >Each party acknowledges that in entering into the Contract it has not relied on, and will have no remedy in respect of, any statement, representation, warranty, understanding, promise or assurance (whether negligently or innocently made) of any person other than as expressly set out in the Contract.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Confidentiality and data protection</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li ><span >Each party will ensure that it:</span></li>
<ol>
<li ><span >keeps the Confidential Information confidential and does not disclose it to any third party; and</span></li>
<li ><span >only uses Confidential Information in relation to the Contract,</span></li>
</ol>
</ol>
</ol>
<p><span >unless otherwise permitted by these Terms.</span></p>
<ol>
<ol>
<li ><span >The commitments in clause 13.1 above </span><strong>do not apply </strong><span >to any Confidential Information which</span> <span >was:</span></li>
<ol>
<li ><span >publicly available before the Start Date or subsequently becomes publicly available through no failure to comply with the Contract;</span></li>
<li ><span >already known to a party or is subsequently legitimately disclosed to a party by a third party without legal restriction; or</span></li>
<li ><span >developed independently by a party without use of or reliance on the Confidential Information received under the Contract.</span></li>
</ol>
<li ><span >A party </span><strong>may disclose </strong><span >the</span><strong> Confidential Information</strong><span >:</span></li>
<ol>
<li ><span >to its Affiliates, agents, contractors and suppliers, provided that: (a) those third parties have entered into non-disclosure agreements no less onerous than as set out in these Terms; and (b) the party disclosing Confidential Information to those third parties ensures and is liable for their compliance with these Terms; and</span></li>
<li ><span >where and to the extent required by applicable law, provided prompt written notice of that requirement is given to the original discloser (where such notice is lawful).</span></li>
</ol>
<li ><span >All Confidential Information disclosed by a party or its Affiliates remains the property of the discloser. Each party must </span><strong>return or, if clearly instructed by the other party, destroy that received Confidential Information </strong><span >remaining in its or its Affiliates' possession or control, within thirty (30) days of written request from the other party. Confidential Information may be retained to the limited extent required as part of securely-held confidential records to be used only to determine and/or comply with legal obligations (including secure electronic backups of these records, which may only be used to replace the permitted records if lost or corrupted).</span></li>
</ol>
</ol>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >Both parties will comply with all the obligations imposed on an independent Data Controllers under the UK Data Protection Legislation, including prompt notification of any potential or actual breach of these obligations. Both parties will always use appropriate technical and organisational measures to protect any of the other party&rsquo;s Personal Data that is held as part of the Services against loss or unauthorised use or access.&nbsp; Capitalised terms used in this clause 13.5 have the meanings given in the UK Data Protection Legislation in force at the time.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Boilerplate</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >The terms and provisions of this Contract are intended solely for the benefit of each party hereto and their respective successors and permitted assigns, and it is not the intention of the parties to confer third-party beneficiary rights upon any other person.</span></li>
<li ><span >The documents comprising the Contract (together with any documents referred to therein or required to be entered into thereunder) contain the entire agreement and understanding between the parties relating to the subject matter of the Contract and supersede all prior agreements, understandings or arrangements (both written and oral) relating to the subject matter of the Contract.</span></li>
<li ><span >In the event of conflict or inconsistency between the Order Form, the Module Terms and these Terms, and between any of the foregoing and a document referred to in the Contract, documents will take precedence in the order listed above.</span></li>
<li ><span >You represent and warrant that the person executing this Contract has the authority to bind you to the terms hereof. You will require any employee, contractor or agent who accesses the Services or Deliverables to adhere to the relevant terms of the Contract.&nbsp;</span></li>
<li ><span >Notices required under Contract will be sent by email to the relevant party&rsquo;s address on the Order Form or as otherwise agreed in writing for such purpose. Notice by email is deemed effective three hours from transmission.&nbsp;</span></li>
<li ><span >The parties acknowledge and agree that our communication may be electronic, and that any communications sent electronically comply with any legal or contractual requirement that such communication be made in writing.</span></li>
<li ><span >We may assign, sub-license or otherwise transfer to any Affiliate the benefit of any of our rights under the Contract if we give you reasonable prior written notice. We may sub-contract our performance of any obligation under the Contract to any of our Affiliates without notice. This will not affect our performance obligations, nor liability to you in relation to the Contract. We will be responsible for any violation of our obligations hereunder by any such sub-contractor. Otherwise, neither party may assign, sub-license, subcontract or otherwise transfer to any third party any of its rights or obligations under the Contract without the other party&rsquo;s prior written consent.&nbsp;</span></li>
<li ><span >If any provision of the Contract is held to be invalid or unenforceable, that portion will be construed in a manner consistent with the applicable law to reflect, as nearly as possible, the original intentions of the parties, and the remainder of the Contract will remain valid and enforceable.</span></li>
<li ><span >Any translations of the Contract from English are provided merely for convenience and will not be legally binding. In the event of any conflict between the English language version and any translations, the English version will prevail.&nbsp;</span></li>
<li ><span >Where these Terms use the words &lsquo;include&rsquo; and &lsquo;including&rsquo;, these are illustrative and not limiting.</span></li>
<li ><span >The Contract will not create, nor will it be construed as creating, any partnership or agency relationship between the parties.</span></li>
<li ><span >Each party will comply with all applicable laws and government regulations which apply to the Contract.</span></li>
<li ><span >Nothing in the Contract will require either party to do or omit to do anything which would contravene any applicable laws or government regulations.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>&nbsp;Law and Jurisdiction; Waiver of Jury Trial</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<ol>
<li ><span >Where the Ascential contracting entity (as identified on the relevant Order Form) is a member of Ascential Europe &ndash; APAC, unless otherwise set out in clause 15.3 of these Terms below;</span></li>
<ol>
<li ><span >the Contract will be governed by and construed with the laws of England and Wales; and</span></li>
<li ><span >the courts of England and Wales will be the exclusive venue for all disputes between the parties arising out of or in connection with this Contract and the parties hereby submit to the personal jurisdiction of, and waive any objections to venue in, such courts.&nbsp;</span></li>
</ol>
<li ><span >Where the Ascential contracting entity (as identified on the relevant Order Form) is a member of Ascential Americas;&nbsp;</span></li>
<ol>
<li ><span >the Contract will be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of laws rules;</span></li>
<li ><span >the state and federal courts located in the City of New York, Borough of Manhattan, New York, will be the exclusive venue for any and all disputes between the parties arising out of or in connection with the Contract and the parties hereby submit to the personal jurisdiction of, and waive any objections to venue in, such courts; and</span></li>
<li ><strong>EACH PARTY HERETO HEREBY WAIVES ITS RIGHT TO A JURY TRIAL IN ANY DISPUTE, ACTION, OR PROCEEDING ARISING OUT OF OR IN CONNECTION WITH THE CONTRACT TO THE MAXIMUM EXTENT PERMITTED BY LAW</strong><span >.&nbsp;&nbsp;</span></li>
</ol>
<li ><span >Where the Ascential contracting entity (as identified on the relevant Order Form) is registered in the People&rsquo;s Republic of China and you are registered in the People&rsquo;s Republic of China;</span></li>
<ol>
<li ><span >the Contract will be governed by the laws of the People&rsquo;s Republic of China; and&nbsp;</span></li>
<li ><span >any dispute arising out of or relating the Contract shall be referred to, and finally settled by, arbitration in Shanghai International Economic and Trade Arbitration Commission .</span></li>
</ol>
<li ><span >This choice of law and jurisdiction does not prevent either party from seeking injunctive relief in any appropriate jurisdiction with respect to violation of Intellectual Property Rights.</span></li>
</ol>
</ol>
</ol>
<p>&nbsp;</p>
<ul>
<li><strong><strong>Definitions&nbsp;</strong></strong></li>
</ul>
<p>&nbsp;</p>
<ol>
<ol>
<li ><span >In these Terms the following definitions apply:</span></li>
</ol>
</ol>
<table>
<tbody>
<tr>
<td>
<p><strong>Affiliates</strong></p>
</td>
<td>
<p><span >means any entity controlled by a party or under a party&rsquo;s common control, where &ldquo;control&rdquo; means: direct or indirect ownership, in an entity of 50% or more of the voting rights conferred by all the issued shares or equity interests in the capital of that entity; </span><strong>or</strong><span > the power to determine directly or indirectly the composition of the majority of the board of directors, similar management body or direct the management of such entity;&nbsp;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Ascential, we, us, our</strong></p>
</td>
<td>
<p><span >means the member of the Ascential group of companies identified on the Order Form;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Ascential Americas</strong></p>
</td>
<td>
<p><span >means any current or future entity which is part of the Ascential Group of companies that is domiciled in the United States;&nbsp;&nbsp;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Ascential Europe - APAC</strong></p>
</td>
<td>
<p><span >means any current or future entity which is part of the Ascential Group companies that is domiciled in a country other than the United States, (with the exception of any entity registered in the People&rsquo;s Republic of China);</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Ascential Property</strong><strong>&nbsp;</strong></p>
<br /><br /><br /></td>
<td>
<p><span >means the Services, the Deliverables (including, without limitation, all derivatives or improvements), any patents, processes, software, code, files, technology, templates, forms, scripting, trade secrets, products, reports, ideas, concepts, operations, plans or intentions, know-how, market opportunities, customers, business affairs, development plans and financial information, any suggestions, information, enhancements, requests, feedback, recommendations or other input provided by any party relating to the Services or Deliverables, and any other items we create in relation to our performance of our obligations pursuant to the Contract;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Applicable Price Index</strong></p>
</td>
<td>
<p><span >means:</span></p>
<ol>
<ol>
<ol>
<ol>
<ol>
<li ><span >where the contracting Ascential entity as identified on the Order Form is a member of Ascential Americas, the Consumer Price Index, all Urban Customers, United States, All Items rate;&nbsp; and,&nbsp;</span></li>
</ol>
</ol>
</ol>
</ol>
</ol>
<br />
<ol>
<ol>
<ol>
<ol>
<ol>
<li ><span >where the Ascential entity as identified on the Order Form is a member of&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ascential Europe &ndash; APAC, the UK Retail Price Index (RPI) All Items rate;</span></li>
</ol>
</ol>
</ol>
</ol>
</ol>
</td>
</tr>
<tr>
<td>
<p><strong>Confidential Information</strong></p>
</td>
<td>
<p><span >means any information, disclosed by a party to the other party, in relation to the Contract, which is designated as confidential, commercially sensitive, or confidential in nature;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Customer Materials</strong></p>
</td>
<td>
<p><span >means anything you provide to us to enable us to perform our obligations pursuant to the Contract;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Deliverables</strong></p>
</td>
<td>
<p><span >means the deliverables described in the Order Form;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Event</strong></p>
</td>
<td>
<p><span >means the event organized and provided by us as set out in the Order Form or Registration form;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Insolvency Event</strong></p>
</td>
<td>
<p><span >means a situation where a party cannot pay its debts as they fall due, has a petition for winding up or an administration order presented against it or passes a resolution for winding up or calls any meeting of its creditors or proposes to make any arrangement with its creditors, has a receiver (administrative or otherwise) or an administrator appointed over all or any part of its business or assets, or goes into liquidation or any event having a similar effect to any of the foregoing applies to a party under the laws of any jurisdiction;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Intellectual Property Rights</strong></p>
<br /><br /></td>
<td>
<p><span >means patents, rights to inventions, copyright and related rights, moral rights, trademarks and service marks, trade names and domain names, rights to goodwill or to sue for passing off or unfair competition, rights in designs, rights in computer software, database rights, rights in confidential information (including know-how and trade secrets) and any other intellectual property rights, in each case whether registered or unregistered and including all applications (or rights to apply) for, and renewals or extensions of, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist now or in the future in any part of the world;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Module Terms</strong></p>
</td>
<td>
<p><span >means terms specific to the Services and/or Deliverables you have ordered from us, which are set out below;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>Services</strong></p>
</td>
<td>
<p><span >means the services described in the Order Form; and&nbsp;</span></p>
</td>
</tr>
<tr>
<td>
<p><strong>UK Data Protection Legislation</strong></p>
</td>
<td>
<p><span >means all applicable data protection and privacy legislation in force from time to time in the UK including the General Data Protection Regulation ((EU) 2016/679); the Data Protection Act 2018; the Privacy and Electronic Communications Directive 2002/58/EC (as updated by Directive 2009/136/EC) and the Privacy and Electronic Communications Regulations 2003 (SI 2003/2426) as amended.</span></p>
</td>
</tr>
</tbody>
</table>
<p><strong>SERVICE SPECIFIC TERMS</strong></p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ul>
<li><strong><strong>MediaLink Beach Online&nbsp; Content Module</strong></strong></li>
</ul>
<p>&nbsp;</p>
<p><span >Where, as part of a Contract, we provide MediaLink Beach Online digital services or deliverables the following additional terms will apply to the Contract.</span></p>
<ol>
<ol>
<li ><span >Subject to early termination in accordance with these Terms, the Contract will continue</span> <span >from 22 June 2020 or, if later, the date on which your order is confirmed to September 21, 2020 (the &ldquo;</span><strong>Initial Period</strong><span >&rdquo;). This will not prevent early termination in accordance with these Terms and we expressly reserve the right to terminate the Contract at any time on written notice.</span></li>
<li ><span >Your access to and use of the Services is restricted to the registered individual (the &ldquo;</span><strong>User</strong><span >&rdquo;) and permitted for internal business operations only.&nbsp; You may not designate any other individuals (including employees and individual contractors of your Affiliates) as Users. You agree not to permit any third-party to access the Services except as expressly authorized in a separate Third-Party Access Agreement provided by us. We will issue usernames and personal passwords to authorize acceptable Users to use the Services. Each username and User access is unique. The User must keep the password confidential and must not share or permit access to the Services by any other person.</span> <span >You shall indemnify us from and against all costs, losses or expenses resulting from any unauthorised use of a username and/or password or account by any unnamed user or third party.&nbsp;</span></li>
<li ><span >Your digital services may be subject to a set-up period during which you may not have access, or may have limited access, to the Services after commencement of the Contract.&nbsp; The length of this set-up period may vary.</span></li>
<li ><span >We make no representations or warranties regarding the reliability, availability, timeliness, suitability, accuracy or completeness of the Services and Deliverables or the results that you may obtain by using them.&nbsp;</span></li>
<li ><span >We do not represent or warrant that:&nbsp;</span></li>
</ol>
</ol>
<ol>
<li><span >a)</span> <span >the operation or use of the Services or Deliverables will be timely, uninterrupted or error-free;&nbsp;</span></li>
<li><span >b)</span> <span >the quality of the Services or Deliverables will meet your requirements; or</span></li>
<li><span >c)</span> <span >the Services or Deliverables will function properly in combination with any third party-services, technology, hardware, software, systems or data.</span></li>
</ol>
<ol>
<ol>
<li ><span >Notwithstanding Clause 12.2.2 above, our total aggregate liability to you arising out of or in connection with the use of MediaLink Beach Online digital services or deliverables will be limited to $500 USD.&nbsp;</span></li>
<li ><span >You acknowledge that the Services and Deliverables may be subject to limitations, delays, loss or corruption of information and other problems inherent in the use of electronic communications facilities.&nbsp;</span></li>
<li ><span >Except where expressly provided otherwise, the Services and Deliverables are provided on an "as is" basis.&nbsp; You are solely responsible for ensuring that the Services and Deliverables are appropriate and suitable for your needs and that the assumptions (if any) set out in the Order Form are accurate.&nbsp;&nbsp;</span></li>
<li ><span >You agree that neither the Services or Deliverables are advice or recommendations from us and you must not rely on them to make decisions.</span></li>
<li ><span >From time to time, we may:</span></li>
</ol>
</ol>
<ol>
<li><span >a) temporarily suspend for the purpose of emergency repair, maintenance or improvement, all or part of any Services or Deliverables without notice;</span></li>
<li><span >b) temporarily suspend all or part of any Services or Deliverables for scheduled support and maintenance by providing notifications and giving reasonable notice of such suspensions;&nbsp;</span></li>
<li><span >c) suspend all or part of any Services or Deliverables without notice if we believe that you have breached a Contract; and</span></li>
<li><span >d) vary the Specification for operational or any other reason, provided that there is no material detriment to the operation of such Services or Deliverables.</span></li>
</ol>
<ol>
<ol>
<li ><span >We reserve the right at any time and from time to time to modify, temporarily or permanently, any Services or Deliverables or any component or feature thereof. You agree that we will not be liable to you or to any third party for any such modification of the Services or Deliverables if there is no material detriment to their operation.</span></li>
<li ><span >Except where expressly provided otherwise, and without limiting your obligations elsewhere in the Contract, you will not disclose, provide, resell or otherwise make available the Services or Deliverables to any third-party, including (without limitation) any retailer, data provider, or manufacturer, unless expressly authorized by us in a separate written agreement.&nbsp; You further agree that you will not, directly or indirectly: (i) reverse engineer, decompile, disassemble or otherwise attempt to discover the source code, object code or underlying structure, ideas or algorithms of the Services or Deliverables except as permitted by applicable law; (ii) modify, translate, or create derivative works based on the Services or Deliverables, or incorporate names or likenesses of individuals, locations, structures or other proprietary material referred to in the Services or Deliverables in or on your products, or copy (except for archival purposes), rent, lease, distribute (except as expressly permitted herein), pledge, assign, or otherwise transfer or encumber rights to the Services or Deliverables; (iii) use or access the Deliverables or Services to build or support, and/or assist a third party in building or supporting, products or services competitive to us, or use (or permit the use of) the Services or Deliverables to generate any statistical information which is sold or otherwise made available to any third party; (iv) remove any proprietary notices or labels from the Services or Deliverables or use our or any third party&rsquo;s trade names, trademarks or service marks in or on your products; (v) use the Services or Deliverables in any manner that could damage, disable, overburden, impair, obstruct or otherwise interfere with our provision of the Services, the Deliverables or our business; (vi) use the Services to store or transmit computer viruses or other harmful code; (vii) interfere with or disrupt the integrity or performance of the Services; (viii)&nbsp; frame or mirror any content forming part of the Services, other than on Customer&rsquo;s own intranet for Customer&rsquo;s internal business operations as permitted under the Contract; (ix) attempt to gain unauthorized access to the Services or its related systems or networks; or (x) permit direct or indirect access to or use of the Services in any manner that circumvents any restrictions or limitations under the Contract.</span></li>
<li ><span >We may limit the data and deliverables that are available on the Services based on either or both of (i) the date of first publication or (ii) the amount of data stored on the Services platform.&nbsp; Thereafter, we may archive the data and deliverables in which case the data may be available via an extract for an additional fee.</span></li>
</ol>
</ol>
<p>&nbsp;</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Terms;